import { render } from "./RiepilogoOrdini.vue?vue&type=template&id=095532aa&scoped=true"
import script from "./RiepilogoOrdini.vue?vue&type=script&lang=js"
export * from "./RiepilogoOrdini.vue?vue&type=script&lang=js"

import "./RiepilogoOrdini.vue?vue&type=style&index=0&id=095532aa&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095532aa"]])

export default __exports__